import NoAccessPage from "@components/common/NoAccess";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import * as React from "react";
import "./fixed-reports.scss";
import { useNavigate } from "react-router-dom";
import MoreReportSvgComponent from "../../../assets/svg-components/left-menu/more-report";
interface IFixedReportsProps {}

const FixedReports: React.FunctionComponent<IFixedReportsProps> = (props) => {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const navigate = useNavigate();
  const [isLoading] = React.useState(true);
  const [list] = React.useState([
    {
      title: "Vendor Reports",
      report_list: [
        {
          report_name: "Uploaded and Not Uploaded Status Reports",
          report_url: "/report/fixed-reports/vendor-audit-uploads",
        },
        {
          report_name: "Daily Audit completed Reports",
          report_url: "/report/fixed-reports/vendor-daily-audit",
        },
        {
          report_name: "Daily Document Uploaded Status Reports",
          report_url: "/report/fixed-reports/vendor-daily-uploads",
        },
        {
          report_name: "Vendor HC Reports",
          report_url: "/report/fixed-reports/headcount",
        },
        {
          report_name: "Consolidated Audit Reports",
          report_url: "/report/fixed-reports/consolidated-audit-reports",
        },
        {
          report_name: "Compliance Task Reports",
          report_url: "/report/fixed-reports/compliance-task-reports",
        },
        {
          report_name: "Vendor Audit Reports",
          report_url: "/report/fixed-reports/vendor-audit",
        },
      ],
    },
    // {
    // 	title: "Head Count",
    // 	report_list: [
    // 		{
    // 			report_name: "Head Count",
    // 			report_url: "/report/fixed-reports/headcount",
    // 		},
    // 	],
    // }
  ]);

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "report_analytics_fixed_report"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {/* <div className="dashboard-wrapper__header d-flex align-items-center">
            <h4 className="dashbaord-wrapper__header-title">Fixed Reports</h4>
            <div className="reports-grid"></div>
          </div> */}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreReportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Reports
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Fixed Reports</h4>
              </div>
            </div>
          </div>
          <div className={`main-page-layout-wrapper`}>
          {/* section p-5 */}
            <div className="admin-wrapper">
              {list.map((item: object, key: number) => {
                return (
                  <div>
                    {/* <div className="d-flex align-items-center mb-2">
                      <h4 className=" dashbaord-wrapper__header-title ms-2">{getValue(item, `title`, "")}</h4>
                    </div> */}
                    <div
                      className="section-item d-flex align-items-center"
                      key={key}
                    >
                      {getValue(item, `report_list`, []).map(
                        (reports: object, index: number) => {
                          return (
                            <div
                              key={index}
                              className={"report_map m-2 cursor-pointer"}
                              onClick={() =>
                                navigate(getValue(reports, `report_url`, ""))
                              }
                            >
                              <div
                                // to={getValue(reports, `report_url`, "")}
                                className={`d-flex align-items-center`}
                              >
                                <img
                                  src="/images/bubble.svg"
                                  className="img-fluid ml-5"
                                />
                                <p className={"link ms-3"}>
                                  {getValue(reports, `report_name`, "")}
                                </p>
                              </div>
                            </div>
                          );
                        }
                      )}
                      <p className="desc">{getValue(item, `desc`, "")}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default FixedReports;
